import { FormattedMessage, useIntl } from 'react-intl';
import { JRCModal } from '../../../JRCModal/templates/JRCModal';
import * as React from 'react';
import { useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { useTheme } from 'styled-components';
import { JRCModalButtonType } from '../../../JRCModal/JRCModalContent';
import { JRCInputFile } from '../JRCInputFile/JRCInputFile';
import { ApiWrapper, jFileLittle } from 'jamespot-user-api';

type JRCTinyMCEFileUploadModalProps = {
    closeHandler: () => void;
    open: boolean;
    token?: string;
};

type FileFormValues = { file: ApiWrapper<jFileLittle>[] };
export const JRCTinyMCEFileUploadModal = ({ open, closeHandler, token }: JRCTinyMCEFileUploadModalProps) => {
    const intl = useIntl();
    const theme = useTheme();
    const form = useForm<FileFormValues>();

    const closeModal = useCallback(() => {
        closeHandler();
        form.reset();
    }, [form, closeHandler]);

    const saveFile = useCallback(() => {
        const file = form.watch('file');
        tinymce.activeEditor.execCommand('CreateLink', true, `/downloadFile.php?id=${file[0].result.id}`);
        tinymce.activeEditor.windowManager.close();
        closeHandler();
    }, [form, closeHandler]);

    let buttons: JRCModalButtonType[] = [
        {
            children: <FormattedMessage id="GLOBAL_Cancel" />,
            color: 'cancel',
            clickHandler: closeModal,
        },
    ];
    if (form.watch('file')) {
        buttons = [
            ...buttons,
            {
                children: <FormattedMessage id="GLOBAL_Save" />,
                color: 'valid',
                clickHandler: saveFile,
            },
        ];
    } else {
        buttons = [
            ...buttons,
            {
                children: <FormattedMessage id="GLOBAL_Save" />,
                color: 'valid',
                clickHandler: saveFile,
                disabled: true,
            },
        ];
    }

    return (
        <JRCModal
            open={open}
            closeHandler={closeModal}
            zIndex={theme.zIndex.tinyMCEModal}
            title={intl.formatMessage({ id: 'GLOBAL_Add_File' })}
            buttons={buttons}
            enableClickAwayCloseModal={false}>
            <JRCInputFile control={form.control} name={'file'} token={token} attrName={'editorFiles'} />
        </JRCModal>
    );
};
